import { ModelApi } from '@/services/api/modelApi'
import { ITax } from '@/modules/accounting/tax/types/taxTypes'

export class TaxEndpoints extends ModelApi<ITax> {
  constructor(urlPath: string) {
    super(urlPath)
  }
}
